<template>
  <div class="user-profile-page">
    <b-card no-body class="p-0 m-0 banner-card">
      <b-card-body class="m-0 p-0">
        <div class="top-banner">
          <div class="bg-filter"></div>
          <b-modal id="profile-images" hide-footer hide-header centered size="lg">
              <img
                v-img-fb="zoomImg"
                alt="img-zoom"
                class="img-fluid rounded mx-auto d-block"
              />
          </b-modal>
          <div class="avatar-image" 
            :style="{
              backgroundImage: `url(${employees_photo.url})`,
            }"
            @click="zoomEvent(employees_photo.url)"
            >
          </div>
        </div>

        <div class="profile-highlight">
          <div class="hightlight-button">
            <edit-form :detail_datas="employees_data" @success="getData()" />
            <change-pass-form :user_data="user_data" @successfuly-update-password="logOut()" />
            <div>
              <b-button variant="danger-light" @click="logOutConfirmation">
                <i class="ri-logout-circle-r-line"></i>
                <span>Log Out</span>
              </b-button>
              <!-- Change Password btn -->
              <b-button variant="warning-light"  v-b-modal="'update-password-' + user_data.id">
                <i class="ri-key-2-line"></i>
                <span>Change Password</span>
              </b-button>
              <!-- Logout -->
            </div>
            <b-btn variant="warning-light" v-b-modal="'profile-edit-form-' + employees_data.id">
                <i class="ri-pencil-line"></i>
                <span>Edit Profile</span>
              </b-btn>

          </div>
          <h4 v-if="employees_data">{{ employees_data.name }}</h4>
          <h3 v-if="employees_data">{{ employees_data.alias }}</h3>
          <p v-if="employees_data">Joined {{ formatDate(employees_data.created_at) }}</p>

          <div class="highlight-list">
            <div
              class="highlight-item"
              v-for="(item, i) in highlight"
              :key="'highlight' + i"
            >
              <div class="highlight-content-wrapper">
                <div class="icon-wrapper">
                  <i
                    :class="{
                      [`ri-${item.icon}`]: true,
                    }"
                  ></i>
                </div>

                <div class="hightlight-text centerize-col">
                  <h4>{{ item.label }}</h4>
                  <p class="highlight-value">
                    {{ item.value | parse("thousandSep") }}
                  </p>
                </div>
              </div>

              <i class="ri-arrow-right-s-line chevron-icon"></i>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-overlay :show="isLoading" bg-color="transparent" blur="2px">
    <!-- LOADING OVERLAY -->
    <template #overlay>
      <div v-if="isLoading" class="text-center py-3">
        <img src="@/assets/lottie/plant.gif" alt="Loading..." style="width: 100px;" />
      </div>
    </template>
    <!-- {{ employees_data }} -->
      <b-row class="profile mt-2">
        <!-- LEFT -->
        <b-col cols="6">
          <!-- User Data -->
          <base-detail-card
            title="Data Employee"
            :fields="fields.main_data"
            :data="{ ...employees_data }"
          >
            <template v-slot:gender="{rowData}">
              <p class="badge border mb-0" :class="rowData.gender == 'male' ? 'border-info' : 'border-warning'">
                {{ rowData.gender == 'male' ? 'Laki-laki': 'Perempuan' }}
              </p>
            </template>
          </base-detail-card>
        </b-col>
        <!-- RIGHT -->

        <b-col cols="6">
          <base-detail-card
            :title="`Role Pengguna`"
            api="user_roles/list"
            :apiParams="{
              user_id: $_sys.userInfo().id
            }"
            :fields="fields.roles"
          >
          </base-detail-card>
        </b-col>
      </b-row>
    </b-overlay>
    <!-- <Maintenance /> -->
     <div class="profile-project" v-if="false">
      <b-card no-body class="profile-info">
        <b-card-header>
          <h4 class="mb-0 pb-0">Personal Information</h4>
        </b-card-header>
        <b-card-body class="pt-4">
          <div class="profile-info-list">
            <div
              class="profile-info-item"
              v-for="(item, i) in profileInfo"
              :key="'profile-info-' + i"
            >
              <i
                :class="{
                  [`ri-${item.icon}`]: true,
                }"
                v-b-tooltip.hover
                :title="item.label"
              ></i>
              <span class="profile-info-value">
                <span v-if="!data">-</span>
                <span v-else>
                  <span v-if="!item.type && data[item.key]">{{
                    data[item.key]
                  }}</span>
                  <b-badge
                    :variant="item.variant"
                    v-else-if="
                      item.type && data[item.key] && item.type == 'badge'
                    "
                  >
                    {{ data[item.key] }}
                  </b-badge>
                  <span v-else-if="item.type === 'date' && data[item.key]">{{
                    data[item.key] | parse("date")
                  }}</span>
                  <div
                    v-else-if="
                      item.type === 'custom' &&
                      item.key == 'corporate' &&
                      data.corporate_id
                    "
                  >
                    <div v-if="data.corporate_id">
                      {{ data.corporate_name }}
                    </div>
                  </div>
                  <span v-else>-</span>
                </span>
              </span>
            </div>
          </div>

          <b-button
            variant="warning-light centerize-row w-100 mt-3 justify-content-center"
          >
            <i class="ri-edit-box-line"></i>
            <span>Edit Profile</span>
          </b-button>
        </b-card-body>
      </b-card>
      <b-card no-body class="project-info">
        <b-card-header>
          <h4 class="mb-0 pb-0">Current Projects</h4>
        </b-card-header>

        <b-card-body>
          <div class="project-info-list">
            <div
              class="project-info-item"
              v-for="(item, i) in projects"
              :key="'project-list-' + i"
            >
              <div class="centerize-row justify-content-between">
                <b-badge variant="light">{{ item.code }}</b-badge>
                <b-badge variant="success">{{
                  item.project_type_name
                }}</b-badge>
              </div>

              <div class="total-tree">
                <span class="value">{{ 1000 | parse("thousandSep") }}</span>
                <span class="label font-weight-300">pohon</span>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import Maintenance from "../../default-page/maintenance.vue";
import "./profile.scss";
import EditForm from "./components/profile-edit-form.vue"
import ChangePassForm from "./components/change-password.vue"
import moment from "moment";

export default {
  name: "profile-user",

  components: {
    EditForm,
    Maintenance,
    ChangePassForm
  },

  data() {
    return {
      isLoading: false,
      fetch: 0,
      data: null,
      formatDate: (date, format = "DD MMM YYYY HH:mm") => {
        return moment(date).format(format);
      },
      user_data: null,
      employees_data: {},
      employees_photo: {},
      zoomImg: null,
      fields:{
        main_data: [
          { key: "name", label: "Nama Lengkap" },
          { key: "alias", label: "Nama Panggilan" },
          { key: "ktp_no", label: "Nomor KTP" },
          { key: "kk_no", label: "Nomor KK" },
          { key: "code", label: "ID Karyawan" },
          { key: "email", label: "Email" },
          { key: "phone", label: "Nomor Telpon/Whatsapp" },
          { key: "gender", label: "Jenis Kelamin" },
          { key: "marrital", label: "Status Perkawinan" },
          { key: "religion", label: "Katolik" },
          { key: "birthday", label: "Tanggal Lahir" },
          { key: "npwp", label: "Nomor NPWP" },
          { key: "job_status", label: "Status Pekerjaan" },
          { key: "blood_type", label: "Golongan Darah" },
        ],
        roles: [
          { key: "program_year", label: "Tahun Program" },
          { key: "role_code", label: "Kode Role" },
        ]
      },
      highlight: [
        {
          label: "Project",
          icon: "file-edit-fill",
          value: 3,
          path: "/orders/project",
        },
        {
          label: "Tree Planted",
          icon: "tree-fill",
          value: 1000000,
          path: "/maindata/land",
        },
        {
          label: "Planting",
          icon: "plant-line",
          value: 10,
          path: "/maindata/land",
        },
        {
          label: "Event",
          icon: "calendar-event-line",
          value: 4,
          path: "/orders/event",
        },
      ],
      projects: [],

      profileInfo: [
        {
          label: "Username",
          icon: "at-line",
          key: "username",
        },
        {
          label: "No HP",
          icon: "phone-fill",
          key: "phone",
        },
        {
          label: "Email",
          icon: "mail-fill",
          key: "email",
        },
        {
          label: "DOB",
          icon: "calendar-line",
          key: "customer_dob",
        },
        {
          label: "Role",
          icon: "user-3-fill",
          key: "role_name",
          type: "badge",
          variant: "info-light",
        },
        {
          label: "Tgl. Bergabung",
          icon: "group-fill",
          type: "date",
          key: "created_at",
        },
        {
          label: "Perusahaan",
          icon: "building-4-fill",
          key: "corporate",
          type: "custom",
        },
      ],
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    zoomEvent(data = null) {
      this.zoomImg = data
      this.$bvModal.show("profile-images");
    },
    getData: async function() {
      const userId = this.$_sys.userInfo().id; 
      this.employees_data = {};
      this.user_data = {};
      if(userId){
        this.isLoading = true;
        const userData = await this.$_api.single("users", null, userId);
        this.user_data = userData.data;
        if(userData.data.employees_id){
          const employeeData = await this.$_api.single("employees", null, userData.data.employees_id);
          
          if(employeeData && employeeData.data){
            this.employees_data = {
              ...this.employees_data,
              ...employeeData.data
            };
            this.employees_photo= employeeData.data.employee_photo
          }
        }
        this.isLoading = false;
      }
    },
    logOutConfirmation: async function(){
      const confirm = await this.$_alert.confirm(
          "Log Out?",
          "Apakah Anda Yakin Ingin Keluar?",
          "Ya, Keluar"
        );
      if (!confirm.isConfirmed) return;
      this.logOut();
    },

    logOut:async function() {
      localStorage.clear();
      this.$router.push({ path: "/login" });
      this.$store.replaceState({
        sideNavPrimary: false,
        sideNavSecondary: false,
        sideNavMobile: false,
      });
      this.$_sys.togleClass("kt_body", "aside-minimize", true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/modules/profile/profile.vue